import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";

const NAMES_BG = [
  "Мария","Елена","Деница","Симона","Кристина","Габриела","Теодора",
  "Виктория","Надежда","Анелия","Радостина","Боряна","Цветелина",
  "Жасмин","Александра","Стефания","Ралица","Миглена","Десислава",
  "Моника","Камелия","Диана","Николета","Вероника","Светла","Ирина",
  "Биляна","Валерия","Гергана","Даниела","Евелина","Зорница","Илияна",
  "Калина","Магдалена","Невена","Снежана","Тихомира","Фани","Христина",
  "Юлия","Ясмина","Адриана","Антония","Бояна","Валентина","Добрина","Емилия",
  "Лиляна","Наталия","Павлина","Румяна","Сильвия","Филипа","Елица",
  "Красимира","Маргарита","Пламена","Веселина","Стефка","Здравка","Розалина",
  "Теменужка","Людмила","Василена","Кремена","Пенка","Станка","Ваня",
  "Добринка","Живка","Зорка","Иванка","Йорданка","Латинка",
  "Маринела","Николина","Огнена","Рада","Стоянка","Тодорка",
  "Христина","Цветанка","Елеонора","Нелли","Офелия","Рени",
  "Соня","Тереза","Анна","Блага","Вера","Геновева","Дафина","Еленка",
  "Жени","Зорица","Искра","Калиопа","Лада","Милена","Нина",
  "Огняна","Пролет","Радка","Светлана","Тодора","Христена",
  "Ани","Ива","Яна","Таня","Катя","Лора","Оля","Поли","Тоня","Нора",
  "Цвети","Женя","Магда","Вики","Деси",
  "Еми","Гери","Кали","Мими","Нели","Пепи","Рали","Сани","Цеци",
  "Ели","Вени","Дени","Лили",
  "Мери","Роси","Бети","Вали","Гали",
];

const NAMES_EN = [
  "Maria","Elena","Denitsa","Simona","Kristina","Gabriela","Teodora",
  "Victoria","Nadezhda","Anelia","Radostina","Boryana","Tsvetelina",
  "Jasmine","Alexandra","Stefania","Ralitsa","Miglena","Desislava",
  "Monica","Kamelia","Diana","Nikoleta","Veronika","Svetla","Irina",
  "Bilyana","Valeria","Gergana","Daniela","Evelina","Zornitsa","Iliyana",
  "Kalina","Magdalena","Nevena","Snezhana","Fani","Hristina",
  "Julia","Yasmina","Adriana","Antonia","Boyana","Valentina","Emilia",
  "Lilyana","Natalia","Pavlina","Rumyana","Silviya","Elitsa",
  "Margarita","Plamena","Veselina","Rozalina",
  "Lyudmila","Vasilena","Vanya",
  "Ivanka","Yordanka","Marinela","Nikolina","Rada","Stoyanka",
  "Eleonora","Nelly","Reni",
  "Sonya","Teresa","Anna","Vera","Dafina",
  "Iskra","Milena","Nina",
  "Svetlana","Todora",
  "Iva","Yana","Tanya","Katya","Laura","Polly","Nora",
  "Vicky","Emmy","Lily",
];

const NAMES_RU = [
  "Мария","Елена","Деница","Симона","Кристина","Габриэла","Теодора",
  "Виктория","Надежда","Анелия","Радостина","Боряна","Цветелина",
  "Жасмин","Александра","Стефания","Ралица","Миглена","Десислава",
  "Моника","Камелия","Диана","Николета","Вероника","Светла","Ирина",
  "Биляна","Валерия","Гергана","Даниела","Эвелина","Зорница","Илияна",
  "Калина","Магдалена","Невена","Снежана","Фани","Христина",
  "Юлия","Ясмина","Адриана","Антония","Бояна","Валентина","Эмилия",
  "Лиляна","Наталия","Павлина","Румяна","Сильвия","Элица",
  "Маргарита","Пламена","Веселина","Розалина",
  "Людмила","Василена","Ваня",
  "Иванка","Йорданка","Маринела","Николина","Рада","Стоянка",
  "Элеонора","Нелли","Рени",
  "Соня","Тереза","Анна","Вера","Дафина",
  "Искра","Милена","Нина",
  "Светлана","Тодора",
  "Ива","Яна","Таня","Катя","Лора","Поли","Нора",
  "Вики","Эмми","Лили",
];

const LAST_INITIALS_BG = "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЮЯ".split("");
const LAST_INITIALS_EN = "ABCDEFGHIJKLMNOPRSTUVYZ".split("");
const LAST_INITIALS_RU = "АБВГДЕЖЗИКЛМНОПРСТУФХЦЧШЭЮЯ".split("");

const ACTIONS_BG = [
  "запази час за класическо почистване на лице",
  "резервира почистване с ултразвук",
  "запази час за масаж на лице, шия и деколте",
  "резервира пилинг на лице",
  "запази час за карбонов пилинг",
  "резервира BB Glow процедура",
  "запази час за мезотерапия на лице",
  "резервира безиглена мезотерапия",
  "запази час за алгинатна маска",
  "резервира HIFU лифтинг",
  "запази час за радиочестотен лифтинг",
  "резервира микродермабразио",
  "запази час за микронидлинг",
  "резервира дарсонвал процедура",
  "запази час за дермапланинг",
  "резервира премахване на капиляри",
  "запази час за лазерна епилация подмишници",
  "резервира лазерна епилация крака",
  "запази час за лазерна епилация бикини",
  "резервира кола маска крака",
  "запази час за кола маска подмишници",
  "резервира кола маска бикини",
  "запази час за електроепилация",
  "запази час за класически масаж",
  "резервира релаксиращ масаж",
  "запази час за дълбокотъканен масаж",
  "резервира антицелулитен масаж",
  "запази час за масаж с вулканични камъни",
  "резервира ароматерапия",
  "запази час за мадеротерапия",
  "резервира рефлексотерапия",
  "запази час за аюрведичен масаж",
  "резервира лечебен масаж",
  "запази час за антицелулитна терапия",
  "резервира LPG терапия",
  "запази час за кавитация",
  "резервира криолиполиза",
  "запази час за лимфен дренаж",
  "резервира пресотерапия",
  "запази час за парафинова терапия",
  "резервира почистване на гръб",
  "запази час за оформяне на вежди",
  "резервира боядисване на вежди",
  "запази час за микроблейдинг",
  "резервира ламиниране на вежди",
  "запази час за депилация на вежди",
  "запази час за мигли класически обем",
  "резервира мигли руски обем",
  "запази час за ламиниране на мигли",
  "резервира боядисване на мигли",
  "запази час за професионален грим",
  "резервира вечерен грим",
  "запази час за сватбен грим",
  "резервира перманентен грим",
  "запази час за оформяне на брада",
  "резервира мъжко подстригване и брада",
  "запази час за бръснене с бръснач",
];

const ACTIONS_EN = [
  "booked a classic facial cleansing",
  "reserved an ultrasound facial",
  "booked a face, neck & décolleté massage",
  "reserved a facial peel",
  "booked a carbon peel",
  "reserved a BB Glow treatment",
  "booked facial mesotherapy",
  "reserved needle-free mesotherapy",
  "booked an alginate mask",
  "reserved a HIFU lift",
  "booked a radio-frequency lift",
  "reserved microdermabrasion",
  "booked microneedling",
  "reserved a darsonval treatment",
  "booked dermaplaning",
  "reserved capillary removal",
  "booked laser hair removal — underarms",
  "reserved laser hair removal — legs",
  "booked laser hair removal — bikini",
  "reserved waxing — legs",
  "booked waxing — underarms",
  "reserved waxing — bikini",
  "booked electrolysis",
  "booked a classic massage",
  "reserved a relaxing massage",
  "booked a deep-tissue massage",
  "reserved an anti-cellulite massage",
  "booked a hot-stone massage",
  "reserved aromatherapy",
  "booked maderotherapy",
  "reserved reflexology",
  "booked an Ayurvedic massage",
  "reserved a therapeutic massage",
  "booked anti-cellulite therapy",
  "reserved LPG therapy",
  "booked cavitation",
  "reserved cryolipolysis",
  "booked lymphatic drainage",
  "reserved pressotherapy",
  "booked paraffin therapy",
  "reserved a back cleansing",
  "booked eyebrow shaping",
  "reserved eyebrow tinting",
  "booked microblading",
  "reserved brow lamination",
  "booked eyebrow waxing",
  "booked classic-volume lashes",
  "reserved Russian-volume lashes",
  "booked lash lamination",
  "reserved lash tinting",
  "booked professional makeup",
  "reserved evening makeup",
  "booked bridal makeup",
  "reserved permanent makeup",
  "booked beard grooming",
  "reserved a men's haircut & beard trim",
  "booked a straight-razor shave",
];

const ACTIONS_RU = [
  "записалась на классическую чистку лица",
  "забронировала ультразвуковую чистку",
  "записалась на массаж лица, шеи и декольте",
  "забронировала пилинг лица",
  "записалась на карбоновый пилинг",
  "забронировала процедуру BB Glow",
  "записалась на мезотерапию лица",
  "забронировала безыгольную мезотерапию",
  "записалась на альгинатную маску",
  "забронировала HIFU-лифтинг",
  "записалась на радиочастотный лифтинг",
  "забронировала микродермабразию",
  "записалась на микронидлинг",
  "забронировала дарсонвализацию",
  "записалась на дермапланинг",
  "забронировала удаление капилляров",
  "записалась на лазерную эпиляцию подмышек",
  "забронировала лазерную эпиляцию ног",
  "записалась на лазерную эпиляцию бикини",
  "забронировала восковую депиляцию ног",
  "записалась на восковую депиляцию подмышек",
  "забронировала восковую депиляцию бикини",
  "записалась на электроэпиляцию",
  "записалась на классический массаж",
  "забронировала расслабляющий массаж",
  "записалась на глубокотканный массаж",
  "забронировала антицеллюлитный массаж",
  "записалась на массаж вулканическими камнями",
  "забронировала ароматерапию",
  "записалась на мадеротерапию",
  "забронировала рефлексотерапию",
  "записалась на аюрведический массаж",
  "забронировала лечебный массаж",
  "записалась на антицеллюлитную терапию",
  "забронировала LPG-терапию",
  "записалась на кавитацию",
  "забронировала криолиполиз",
  "записалась на лимфодренаж",
  "забронировала прессотерапию",
  "записалась на парафинотерапию",
  "забронировала чистку спины",
  "записалась на оформление бровей",
  "забронировала окрашивание бровей",
  "записалась на микроблейдинг",
  "забронировала ламинирование бровей",
  "записалась на депиляцию бровей",
  "записалась на наращивание ресниц — классика",
  "забронировала наращивание ресниц — русский объём",
  "записалась на ламинирование ресниц",
  "забронировала окрашивание ресниц",
  "записалась на профессиональный макияж",
  "забронировала вечерний макияж",
  "записалась на свадебный макияж",
  "забронировала перманентный макияж",
  "записался на оформление бороды",
  "забронировал мужскую стрижку и бороду",
  "записался на бритьё опасной бритвой",
];

const CITIES_BG = [
  "София","Пловдив","Варна","Бургас","Стара Загора","Русе","Плевен",
  "Велико Търново","Габрово","Хасково","Пазарджик","Перник","Шумен",
  "Сливен","Добрич","Видин","Монтана","Враца","Ловеч","Търговище",
  "Кърджали","Разград","Силистра","Смолян","Благоевград","Кюстендил",
];

const CITIES_EN = [
  "Sofia","Plovdiv","Varna","Burgas","Stara Zagora","Ruse","Pleven",
  "Veliko Tarnovo","Gabrovo","Haskovo","Pazardzhik","Pernik","Shumen",
  "Sliven","Dobrich","Vidin","Montana","Vratsa","Lovech","Targovishte",
  "Kardzhali","Razgrad","Silistra","Smolyan","Blagoevgrad","Kyustendil",
];

const CITIES_RU = [
  "София","Пловдив","Варна","Бургас","Стара Загора","Русе","Плевен",
  "Велико Тырново","Габрово","Хасково","Пазарджик","Перник","Шумен",
  "Сливен","Добрич","Видин","Монтана","Враца","Ловеч","Търговище",
  "Кырджали","Разград","Силистра","Смолян","Благоевград","Кюстендил",
];

const LOCALE_DATA = {
  bg: { names: NAMES_BG, initials: LAST_INITIALS_BG, actions: ACTIONS_BG, cities: CITIES_BG },
  en: { names: NAMES_EN, initials: LAST_INITIALS_EN, actions: ACTIONS_EN, cities: CITIES_EN },
  ru: { names: NAMES_RU, initials: LAST_INITIALS_RU, actions: ACTIONS_RU, cities: CITIES_RU },
};

const FEMALE_PHOTOS = [
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1548142813-c348350df52b?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1586297135537-94bc9ba060aa?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1614204424926-196a80bf0be8?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1618641986557-1ecd230959aa?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1502767089025-6572583495f9?w=60&h=60&fit=crop&crop=face",
  "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=60&h=60&fit=crop&crop=face",
];

const DICEBEAR_SEEDS = [
  "aria","bella","cara","dana","eva","fiona","grace","hana","iris","julia",
  "kara","luna","maya","nina","ora","petra","quinn","rosa","sara","tina",
  "uma","vera","wanda","xena","yara","zara","alba","bina","cleo","dina",
  "edna","fara","gina","hera","ines","jana","kira","lena","mina","nora",
];

const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];
const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

export default function ActivityTicker() {
  const { t, i18n } = useTranslation('home');
  const lang = i18n.language;

  const data = LOCALE_DATA[lang] || LOCALE_DATA.bg;

  const generateItem = useCallback(() => {
    const usePhoto = Math.random() < 0.5;
    return {
      name: `${rand(data.names)} ${rand(data.initials)}.`,
      action: rand(data.actions),
      city: rand(data.cities),
      ago: t('ticker_ago', { count: randInt(1, 45) }),
      avatarUrl: usePhoto
        ? rand(FEMALE_PHOTOS)
        : `https://api.dicebear.com/8.x/lorelei/svg?seed=${rand(DICEBEAR_SEEDS)}&backgroundColor=ffd5dc,ffdfbf,d1d4f9,c0aede,b6e3f4`,
      isPhoto: usePhoto,
    };
  }, [data, t]);

  return <ActivityTickerInner generateItem={generateItem} />;
}

function ActivityTickerInner({ generateItem }) {
  const [item, setItem] = useState(() => generateItem());
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let outerTid, innerTid;
    const schedule = () => {
      outerTid = setTimeout(() => {
        setVisible(false);
        innerTid = setTimeout(() => {
          setItem(generateItem());
          setVisible(true);
          schedule();
        }, 400);
      }, randInt(5000, 60000));
    };
    schedule();
    return () => { clearTimeout(outerTid); clearTimeout(innerTid); };
  }, [generateItem]);

  return (
    <div className="mt-6 flex items-center gap-3">
      <div
        className="flex items-center gap-2.5 px-3 py-2 rounded-2xl"
        style={{
          background: "rgba(255,255,255,0.72)",
          backdropFilter: "blur(8px)",
          border: "1.5px solid rgba(139,111,212,0.30)",
          opacity: visible ? 1 : 0,
          transform: visible ? "translateY(0)" : "translateY(4px)",
          transition: "opacity 0.4s ease, transform 0.4s ease",
          minWidth: 0,
        }}
      >
        <div className="relative flex-shrink-0">
          <img
            key={item.avatarUrl}
            src={item.avatarUrl}
            alt=""
            className="w-7 h-7 rounded-full border-2 border-white"
            style={item.isPhoto ? { objectFit: "cover" } : { background: "#fdf4ff" }}
          />
          <span
            className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 border-white"
            style={{ background: "var(--color-green)" }}
          />
        </div>
        <div className="min-w-0">
          <p className="text-xs font-semibold text-[#1e1b2e] leading-tight truncate">
            <span style={{ color: "var(--color-primary-strong)" }}>{item.name}</span>
            {" "}{item.action}
            {" • "}<span className="text-[#8f8ca6]">{item.city}</span>
          </p>
          <p className="text-[10px] text-stone-400 leading-tight">{item.ago}</p>
        </div>
      </div>
    </div>
  );
}